import moment from "moment";
import { useEffect, useState } from "react";
import { Badge, ListGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../api"
import { Numeral } from "../../../components/Numeral";
import { ICargo, INftAssetTrxHistory } from "../../../interfaces";
import { Utils } from "../../../utils";

export const NftOrderHistoryPage = () => {
  const projectCode = 'NFT';
  const api = useApi(projectCode);
  const navitate = useNavigate();
  const [mounted, setMounted] = useState<Boolean>(false);
  const [trxs, setTrxs] = useState<INftAssetTrxHistory[]>([]);

  useEffect(() => {
    if (mounted) return;
    setMounted(true);
    api.getNftTrxHistories((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setTrxs(cargo.info);
      }
    })
  }, [api, mounted])

  return (
    <>
      <ListGroup as="ol" className="p-3">
        {
          trxs.map((trx, index) => {
            return (
              <ListGroup.Item as="li" key={index} className="d-flex justify-content-between align-items-start cursor-pointer p-3" onClick={() => {
                navitate(Utils().getNftDetailPath(trx.nftId))
              }}>
                <img src={trx.asset.image 
                  ? Utils().normalizeImagePath(trx.asset.image, projectCode) 
                  : require('../../../assets/img/star/logor.png')} 
                  alt="" 
                  className="rlogo cursor-pointer"
                />
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{trx.asset.name}</div>
                  <div className="text-sm">{trx.fromProfile.nickname} / {trx.toProfile.nickname}</div>
                </div>
                <div className="text-sm pr-3 text-gray-500">{moment(trx.generatedTimestamp).format('YYYY-MM-DD HH:mm:ss')}</div>
                <Badge bg="primary" pill>
                  $ <Numeral value={trx.buyingPrice} />
                </Badge>
              </ListGroup.Item>
            )
          })
        }
      </ListGroup>
    </>
  )
}